import React, { createContext, useState, useCallback } from 'react';
import { tagRelationships } from '../data/tags';

export const TagContext = createContext();

export function TagProvider({ children }) {
  const [activeTag, setActiveTag] = useState(null);
  const [relatedTags, setRelatedTags] = useState([]);

  const handleTagSelect = useCallback((tag) => {
    if (activeTag === tag) {
      setActiveTag(null);
      setRelatedTags([]);
    } else {
      setActiveTag(tag);
      // Get related tags
      const related = tagRelationships[tag.toLowerCase()] || [];
      setRelatedTags(related);
    }
  }, [activeTag]);

  return (
    <TagContext.Provider value={{ 
      activeTag, 
      relatedTags,
      handleTagSelect 
    }}>
      {children}
    </TagContext.Provider>
  );
} 